import React from 'react';
import { ReplaceSlideContent } from '@src/slide/application/service/ai-replace-slide/components/mobile/replace-slide-content';
import { IUiDataService } from '@src/slide/domain/ui-model/service/ui-data-service.interface';
import { IAIAssistantService } from '@src/slide/application/service/ai-ssistant/ai-ssistant-service.interface';
import { ISlideModel } from '@src/slide/domain/ui-model/element-modeles/Interface/slide-model.interface';

interface IReplaceSlideAIMobileContainerProps {
    onClose: () => void;
    startCurrentId: string;
    sourceSlideModel?: ISlideModel | undefined;
    notShowTitle?: boolean;
    uiDataService: IUiDataService;
    aiAssistantService?: IAIAssistantService;
}

export const ReplaceSlideAIMobileContainer = ({
    onClose,
    startCurrentId,
    sourceSlideModel,
    notShowTitle,
    uiDataService,
    aiAssistantService,
}: IReplaceSlideAIMobileContainerProps) => {
    if (!aiAssistantService) {
        return <></>;
    }
    return (
        <div style={{ overflow: 'auto' }}>
            <ReplaceSlideContent
                onClose={() => onClose()}
                startCurrentId={startCurrentId}
                sourceSlideModel={sourceSlideModel}
                notShowTitle={notShowTitle}
                uiDataService={uiDataService}
                aiAssistantService={aiAssistantService}
            />
        </div>
    );
};
